import { BaseResponse } from "@/types/dto/base-response";
import { LoginPayload } from "@/types/payload/sign-in-payload";
import { AxiosInstance } from "axios";
import { AccessTokenDto } from "../types/dto/access-token-dto";
import { baseApi } from "./base-api";

enum SystemServiceEndpoint {
  Login = "/auth/sign-in",
}

class SystemService {
  private static instance: SystemService;
  private _api: AxiosInstance;

  private constructor(api: AxiosInstance) {
    this._api = api;
  }

  static getInstance(apiClient = baseApi): SystemService {
    if (!SystemService.instance) {
      SystemService.instance = new SystemService(apiClient);
    }
    return SystemService.instance;
  }

  async login(
    payload: LoginPayload
  ): Promise<BaseResponse<AccessTokenDto, LoginPayload>> {
    try {
      const response = await this._api.post<
        BaseResponse<AccessTokenDto, LoginPayload>
      >(SystemServiceEndpoint.Login, {
        email: payload.email,
        password: payload.password,
      });

      const responseData = response.data;
      if (responseData.ok) {
        localStorage.setItem("accessToken", responseData.data.access_token);
      }
      return responseData;
    } catch (error) {
      console.error("Error login:", error);
      throw error;
    }
  }

  async uploadFile(
    folderName: string,
    fileName: string,
    file: File
  ): Promise<BaseResponse<{ url: string }, void>> {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await this._api.put<BaseResponse<{ url: string }, void>>(
        `/system/file/${folderName}/${fileName}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.ok) {
        console.log("파일이 성공적으로 업로드되었습니다:", response.data);
      } else {
        console.error("파일 업로드 실패:", response.statusText);
      }
      return response.data;
    } catch (error) {
      console.error("파일 업로드 중 오류 발생:", error);
      throw error;
    }
  }

  async deleteFile(
    folderName: string,
    fileName: string
  ): Promise<BaseResponse<void, void>> {
    try {
      const response = await this._api.delete<BaseResponse<void, void>>(
        `/system/file/${folderName}/${fileName}`
      );

      if (response.data.ok) {
        console.log("파일이 성공적으로 삭제되었습니다:", response.data);
      } else {
        console.error("파일 삭제 실패:", response.statusText);
      }
      return response.data;
    } catch (error) {
      console.error("파일 삭제 중 오류 발생:", error);
      throw error;
    }
  }
}

export const systemService = SystemService.getInstance(baseApi);
